import type { ReactNode } from "react";
import styles from "./HandbookColumn.css";

type HandbookColumnProps = {
  children: ReactNode;
};

const HandbookColumn = ({ children }: HandbookColumnProps) => (
  <div className={styles.root}>{children}</div>
);

export default HandbookColumn;
